
import Vue from "vue";
import {mapState, mapActions } from "vuex";
import AlcoholWarningDialog from "../AlcoholWarningDialog.vue";
import TobaccoWarningDialog from "../TobaccoWarningDialog.vue";

export default Vue.extend({
  name: "category-card",

  components: { 
    "alcohol-warning-dialog": AlcoholWarningDialog,
    "tobacco-warning-dialog": TobaccoWarningDialog
  },

  props: {
    loading: {
      required: false,
      default: false,
      type: Boolean
    },

    department: {
      required: true,
      type: Object
    },

    index: {
      required: true,
      type: Number
    },

    elementWidth: {
      required: false,
      default: '80px'
    },

    elementHeight: {
      required: false,
      default: '80px'
    },
  },

  data: () => ({
    alcoholWarningDialog: false as boolean,
    tobaccoWarningDialog: false as boolean,
  }),

  computed:{
    ...mapState("partner",["partnerSettings"]),
    ...mapState("store",["selectedStoreDetails"]),
  },


  methods: {

    getToUrl(): any {
      return {
            name: "categoriesPage",
            params: {
              departmentId: this.department.id,
              departmentName: this.department.name,             
            }
        }
    },

    proceed(skipCheck: boolean = false) {

      if(skipCheck == false) {
        if(this.department.isAlcohol == true) {
          this.alcoholWarningDialog = true;
        }

        else if(this.department.isTobacco == true) {
          this.tobaccoWarningDialog = true;
        }
      }

      else {
        this.$router.push(this.getToUrl())
      }
    },


     

    // categories image url
    getImgUrl(item: any): string {
      const image = item.imageURL || item.image;

      // imageURL can hold either a full url or just an image name, unlike image which is always just a name
      if(/^https?:\/\//i.test(image))
        return image;

      return (this as any).partnerSettings.blobUrl + `departments/${(this as any).partnerSettings.partnerId}/${image}`;
    }
    
  },

});
